
import _ from 'lodash';
import { Event } from '../types/event';
import Utils from './utils';

const advertisements: Event[] = [
    {
        "prefecture": 0,
        "eventId": 1001,
        "category": 0,
        "title": "ビッグホリデー",
        "place": "",
        "geometry": {
            "type": "Point",
            "coordinates": [
                0,
                0, 
            ]
        },
        "description": "国内旅行の格安予約なら",
        "image": "advert-3",
        "url": "https://px.a8.net/svt/ejp?a8mat=453KVJ+1RPKOI+57BW+601S1",
        "startDate": "",
        "endDate": ""
    },
    {
        "prefecture": 0,
        "eventId": 1002,
        "category": 0,
        "title": "トラベリスト",
        "place": "",
        "geometry": {
            "type": "Point",
            "coordinates": [
                0,
                0, 
            ]
        },
        "description": "国内ホテル・宿泊・旅館予約",
        "image": "advert-4",
        "url": "https://px.a8.net/svt/ejp?a8mat=453KVJ+61BER6+4XZI+BXIYP",
        "startDate": "",
        "endDate": ""
    },
    {
        "prefecture": 0,
        "eventId": 1003,
        "category": 0,
        "title": "駐車場予約サービス特P",
        "place": "",
        "geometry": {
            "type": "Point",
            "coordinates": [
                0,
                0, 
            ]
        },
        "description": "おトクな駐車場を探せる、予約できる。",
        "image": "advert-5",
        "url": "https://px.a8.net/svt/ejp?a8mat=453KVI+G99ALU+43U8+C465T",
        "startDate": "",
        "endDate": ""
    },
    {
        "prefecture": 0,
        "eventId": 1004,
        "category": 0,
        "title": "たびらいレンタカー",
        "place": "",
        "geometry": {
            "type": "Point",
            "coordinates": [
                0,
                0, 
            ]
        },
        "description": "格安レンタカー比較・予約・乗り捨て",
        "image": "advert-6",
        "url": "https://px.a8.net/svt/ejp?a8mat=453KVJ+5ZJ3XU+1EQO+TX15D",
        "startDate": "",
        "endDate": ""
    },
    {
        "prefecture": 0,
        "eventId": 1005,
        "category": 0,
        "title": "ゆめやど(平日宿泊)",
        "place": "",
        "geometry": {
            "type": "Point",
            "coordinates": [
                0,
                0, 
            ]
        },
        "description": "平日お得な宿泊ならゆめやどにおまかせ",
        "image": "advert-7",
        "url": "https://px.a8.net/svt/ejp?a8mat=453KVJ+77L6PE+44YI+HY069",
        "startDate": "",
        "endDate": ""
    }
]

/**
 * 広告を返す
 * @returns 
 */
const getAdvertisement = (): Event[] => {
    let addIndex = 0;
    return _.map(advertisements, (advert: Event, index: number) => {
        advert.startDate = Utils.getIncrementDate(index + addIndex);
        advert.endDate = Utils.getIncrementDate(index + addIndex);
        addIndex++;
        return advert;
    });
}

export default getAdvertisement;